import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/axios';
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import moment from 'moment';

Vue.config.devtools = true;
Vue.config.productionTip = false

Vue.prototype.$config = {
  maxItensPerPage: 10,
  pagingProps: {
    'items-per-page-options': [5, 10, 50, 100],
    'items-per-page-text': 'Itens por página'
  }
}

Vue.filter('formatDate_BR', value => {
  if (value) {
    return moment(value).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateTime_BR', value => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm');
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
